// src/pages/AdminSallesGroupes.jsx
import React, { useEffect, useState } from 'react';
import PageLayout from '../components/PageLayout';
import Button from '../components/Button';
import {
  listEntites,
  createEntite,
  updateEntite,
  createEtablissement,
  updateEtablissement,
  createSalle,
  updateSalle,
  listGroups,
  createGroup,
  updateGroup,
  deleteGroup,
  addSalleToGroup,
  listTypesSalles,
} from '../api/salles';
import toast from 'react-hot-toast';
import { Edit, CirclePlus, ChevronDown, ChevronRight, Trash2, Cog} from 'lucide-react';
import { createPortal } from 'react-dom';
export default function AdminSallesGroupes(){

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const [entities, setEntities] = useState([]);
  const [groups, setGroups] = useState([]);
  const [typesSalles, setTypesSalles] = useState([]);

  const [concernedEntity, setConcernedEntity] = useState({libelle: '', entity_id: ''});
  const [concernedEtablissement, setConcernedEtablissement] = useState({libelle: '', etablissement_id: ''});

  const [openIds, setOpenIds] = useState(new Set());

  const [createEntiteOpen, setCreateEntiteOpen] = useState(false);
  const [createEntiteForm, setCreateEntiteForm] = useState({ libelle: '' });
  const [updateEntiteOpen, setUpdateEntiteOpen] = useState(false);
  const [updateEntiteForm, setUpdateEntiteForm] = useState({});

  const [createEtablissementOpen, setCreateEtablissementOpen] = useState(false);
  const [createEtablissementForm, setCreateEtablissementForm] = useState({ libelle: '' });
  const [updateEtablissementOpen, setUpdateEtablissementOpen] = useState(false);
  const [updateEtablissementForm, setUpdateEtablissementForm] = useState({});

  const [createSalleOpen, setCreateSalleOpen] = useState(false);
  const [createSalleForm, setCreateSalleForm] = useState({ nom: '', type: '' });
  const [updateSalleOpen, setUpdateSalleOpen] = useState(false);
  const [updateSalleForm, setUpdateSalleForm] = useState({});

  const [createGroupOpen, setCreateGroupOpen] = useState(false);
  const [createGroupForm, setCreateGroupForm] = useState({});
  const [updateGroupOpen, setUpdateGroupOpen] = useState(false);
  const [updateGroupForm, setUpdateGroupForm] = useState({});
  const [deleteGroupOpen, setDeleteGroupOpen] = useState(false);
  const [deleteGroupForm, setDeleteGroupForm] = useState({});

  const [addSalleToGroupOpen, setAddSalleToGroupOpen] = useState(false);
  const [addSalleToGroupForm, setAddSalleToGroupForm] = useState({});

  const handleSetUpdateEntiteForm = (entite) => {
    setUpdateEntiteForm({
      libelle: entite.entite_libelle,
      entite_id: entite.entite_id
    });
  };

  const handleSetUpdateEtablissementForm = (etablissement) => {
    setUpdateEtablissementForm({
      libelle: etablissement.etablissement_libelle,
      etablissement_id: etablissement.etablissement_id,
      trigramme: etablissement.etablissement_trigramme,
    });
  };

  const handleSetUpdateSalleForm = (salle) => {
    setUpdateSalleForm({
      nom: salle.salle_nom,
      type: salle.salle_type,
      salle_id: salle.salle_id
    });
  };

  const handleSetUpdateGroupForm = (group) => {
    setUpdateGroupForm({
      libelle: group.group_libelle,
      group_id: group.group_id
    });
  };

  const handleSetDeleteGroupForm = (group) => {
    setDeleteGroupForm({
      group_id: group.group_id,
      libelle: group.group_libelle,
      nbSalles: group.salles.length
    });
  };

  const handleSetAddSalleToGroupForm = (group, etablissement) => {
    setAddSalleToGroupForm({
      etablissement_salles: etablissement.salles,
      group_salles: group.salles,
      group_id: group.group_id,
      group_libelle: group.group_libelle,
    });
  };

  function toggle(id) {
    setOpenIds((prev) => {
      const n = new Set(prev);
      n.has(id) ? n.delete(id) : n.add(id);
      return n;
    });
  }

  function countSallesPerEntity(entite) {
    return entite.etablissements.reduce((total, etab) => total + etab.salles.length, 0);
  }

  function countGroupsPerEtablissement(etablissement) {
    const filteredGroups = groups.filter(
      (mGroup) => mGroup.etablissement.etablissement_id === etablissement.etablissement_id,
    );
    return filteredGroups.length;
  }

  function toggleSalle(salle, checked) {
    setAddSalleToGroupForm((prev) => {
      const nextSalles = [...prev.group_salles];
      const index = nextSalles.findIndex((s) => s.salle_id === salle.salle_id);
      if (checked && index === -1) {
        nextSalles.push(salle);
      }
      if (!checked && index !== -1) {
        nextSalles.splice(index, 1);
      }
      return {
        ...prev,
        group_salles: nextSalles,
      };
    });
  }


  const refresh = async () => {
    setError('');
    setLoading(true);
    try {
      const data = await listEntites();
      const fGroups = await listGroups();
      const fts = await listTypesSalles();

      setEntities(data);
      setGroups(fGroups);
      setTypesSalles(fts);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);


  const onCreateEntite = async (e) => {
    e.preventDefault();
    try {
      if (!createEntiteForm.libelle?.trim()) {
        throw new Error('Libelle requis');
      }

      const payload = { ...createEntiteForm };
      await createEntite(payload);
      toast.success('Entité créée');
      setCreateEntiteOpen(false);
      setCreateEntiteForm({
        libelle: ''
      });
      await refresh();
    } catch (e) {
      toast.error(e.message);
    }
  };

  const onUpdateEntite = async (e) => {
    e.preventDefault();
    try {
      if (!updateEntiteForm.libelle?.trim()) {
        throw new Error('Libelle requis');
      }
      const payload = { ...updateEntiteForm };
      await updateEntite(updateEntiteForm.entite_id, payload);
      toast.success('Entité modifiée');
      setUpdateEntiteOpen(false);
      setUpdateEntiteForm({});
      await refresh();
    } catch (e) {
      toast.error(e.message);
    }
  };

   const onCreateEtablissement = async (e) => {
     e.preventDefault();
     try {
       if (!createEtablissementForm.libelle?.trim()) {
         throw new Error('Libelle requis');
       }

       if (!createEtablissementForm.trigramme?.trim()) {
         throw new Error('Trigramme requis');
       }

       if (!concernedEntity?.entite_id?.trim()) {
         throw new Error('entite_id requis');
       }

       const payload = { ...createEtablissementForm, entite_id: concernedEntity.entite_id };
       await createEtablissement(payload);
       toast.success('Établissement créé');
       setCreateEtablissementOpen(false);
       setCreateEtablissementForm({ libelle: ''});
       await refresh();
     } catch (e) {
       toast.error(e.message);
     }
   };

  const onUpdateEtablissement = async (e) => {
    e.preventDefault();
    try {
      if (!updateEtablissementForm.libelle?.trim()) {
        throw new Error('Libelle requis');
      }

      if (!updateEtablissementForm.trigramme?.trim()) {
        throw new Error('Trigramme requis');
      }
      const payload = { ...updateEtablissementForm };
      await updateEtablissement(updateEtablissementForm.etablissement_id, payload);
      toast.success('Etablissement modifié');
      setUpdateEtablissementOpen(false);
      setUpdateEtablissementForm({});
      await refresh();
    } catch (e) {
      toast.error(e.message);
    }
  };

   const onCreateSalle = async (e) => {
     e.preventDefault();
     try {
       if (!createSalleForm.nom?.trim()) {
         throw new Error('Nom requis');
       }

       if (!createSalleForm.type?.trim()) {
         throw new Error('Type requis');
       }

       if (!concernedEtablissement?.etablissement_id?.trim()) {
         throw new Error('etablissement_id requis');
       }

       const payload = { ...createSalleForm, etablissement_id: concernedEtablissement.etablissement_id };
       await createSalle(payload);
       toast.success('Salle créée');
       setCreateSalleOpen(false);
       setCreateSalleForm({ nom: '', type: ''});
       await refresh();
     } catch (e) {
       toast.error(e.message);
     }
   };

  const onUpdateSalle = async (e) => {
    e.preventDefault();
    try {
      if (!updateSalleForm.nom?.trim()) {
        throw new Error('Nom requis');
      }

      if (!updateSalleForm.type?.trim()) {
        throw new Error('Type requis');
      }

      const payload = { ...updateSalleForm };
      await updateSalle(updateSalleForm.salle_id, payload);
      toast.success('Salle modifiée');
      setUpdateSalleOpen(false);
      setUpdateSalleForm({});
      await refresh();
    } catch (e) {
      toast.error(e.message);
    }
  };

  const onCreateGroup = async (e) => {
    e.preventDefault();
    try {
      if (!createGroupForm.libelle?.trim()) {
        throw new Error('Libelle requis');
      }

      if (!concernedEtablissement?.etablissement_id?.trim()) {
        throw new Error('etablissement_id requis');
      }

      const payload = {
        ...createGroupForm,
        etablissement_id: concernedEtablissement.etablissement_id,
      };
      await createGroup(payload);
      toast.success('Groupe créée');
      setCreateGroupOpen(false);
      setCreateGroupForm({});
      await refresh();
    } catch (e) {
      toast.error(e.message);
    }
  };

  const onUpdateGroup = async (e) => {
    e.preventDefault();
    try {
      if (!updateGroupForm.libelle?.trim()) {
        throw new Error('Libelle requis');
      }

      const payload = { ...updateGroupForm };
      await updateGroup(updateGroupForm.group_id, payload);
      toast.success('Groupe modifié');
      setUpdateGroupOpen(false);
      setUpdateGroupForm({});
      await refresh();
    } catch (e) {
      toast.error(e.message);
    }
  };
  const onAddSalleToGroup = async (e) => {
    e.preventDefault();
    try {
      if (!addSalleToGroupForm.group_id?.trim()) {
        throw new Error('Group_id requis');
      }
      if (!Array.isArray(addSalleToGroupForm.group_salles)) {
        throw new Error('Group_salles requis');
      }

      const payload = { ...addSalleToGroupForm };
      await addSalleToGroup(addSalleToGroupForm.group_id, payload);
      toast.success('Salles du groupe modifiées');
      setAddSalleToGroupOpen(false);
      setAddSalleToGroupForm({});
      await refresh();
    } catch (e) {
      toast.error(e.message);
    }
  };

  const onDeleteGroup = async (e) => {
    e.preventDefault();
    try {
      if (!deleteGroupForm.group_id?.trim()) {
        throw new Error('groupe_id requis');
      }
      await deleteGroup(deleteGroupForm.group_id);
      toast.success('Groupe modifié');
      setDeleteGroupOpen(false);
      setDeleteGroupForm({});
      await refresh();
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <PageLayout title="Administration — Salles et Groupes">
      <div className="px-4 pt-2 pb-2">
        <div className="flex items-center justify-between mb-3">
          <h1 className="text-xl font-semibold">Gestion des entités</h1>
          <div className="flex gap-2">
            <Button
              type="button"
              className="!opacity-100"
              onClick={() => setCreateEntiteOpen((v) => !v)}
            >
              <CirclePlus size={16} className="inline-block" />
              {createEntiteOpen ? 'Fermer' : 'Nouvelle entité'}
            </Button>
          </div>
        </div>
      </div>

      {createEntiteOpen &&
        createPortal(
          <div className="fixed top-0 left-0 w-full h-[100vh] z-[1002] flex items-center justify-center bg-black/30">
            <div
              className="absolute inset-0 bg-black/30"
              onClick={() => setCreateEntiteOpen(false)}
            />
            <form
              onSubmit={onCreateEntite}
              className="relative z-10  w-max[80vw]  md:max-w-3xl mx-3 rounded-2xl bg-white shadow-xl p-4 grid grid-cols-1 md:grid-cols-2 gap-2"
            >
              <div className="md:col-span-2">
                <h2 className="text-lg font-semibold mb-1">Nouvelle Entité</h2>
              </div>
              <div className="md:col-span-2">
                <label>Libellé:</label>
                <input
                  className="w-full rounded-lg border border-gray-300 md:col-span-2 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Libelle"
                  value={createEntiteForm.libelle}
                  onChange={(e) => setCreateEntiteForm((f) => ({ ...f, libelle: e.target.value }))}
                />
              </div>
              <div className="md:col-span-2 flex justify-end gap-2 mt-2">
                <Button type="button" onClick={() => setCreateEntiteOpen(false)}>
                  Annuler
                </Button>
                <Button type="submit">Créer</Button>
              </div>
            </form>
          </div>,
          document.body,
        )}

      {updateEntiteOpen &&
        createPortal(
          <div className="fixed top-0 left-0 w-full h-[100vh] z-[1002] flex items-center justify-center bg-black/30">
            <div
              className="absolute inset-0 bg-black/30"
              onClick={() => setUpdateEntiteOpen(false)}
            />
            <form
              onSubmit={onUpdateEntite}
              className="relative z-10  w-max[80vw]  md:max-w-3xl mx-3 rounded-2xl bg-white shadow-xl p-4 grid grid-cols-1 md:grid-cols-2 gap-2"
            >
              <div className="md:col-span-2">
                <h2 className="md:col-span-2 text-lg font-semibold mb-1">Modifier l'entité</h2>
              </div>
              <div className="md:col-span-2">
                <label>Libellé:</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Libelle"
                  value={updateEntiteForm.libelle}
                  onChange={(e) => setUpdateEntiteForm((f) => ({ ...f, libelle: e.target.value }))}
                />
              </div>
              <div className="md:col-span-2 flex justify-end gap-2 mt-2">
                <Button type="button" onClick={() => setUpdateEntiteOpen(false)}>
                  Annuler
                </Button>
                <Button type="submit">Modifier</Button>
              </div>
            </form>
          </div>,
          document.body,
        )}

      {createEtablissementOpen &&
        createPortal(
          <div className="fixed top-0 left-0 w-full h-[100vh] z-[1002] flex items-center justify-center bg-black/30">
            <div
              className="absolute inset-0 bg-black/30"
              onClick={() => setCreateEtablissementOpen(false)}
            />
            <form
              onSubmit={(e) => onCreateEtablissement(e)}
              className="relative z-10  w-max[80vw]  md:max-w-3xl mx-3 rounded-2xl bg-white shadow-xl p-4 grid grid-cols-1 md:grid-cols-4 gap-2"
            >
              <div className="md:col-span-4">
                <h2 className="text-lg font-semibold mb-1">
                  Nouvel Établissement pour l'entité{' '}
                  <span className="bg-slate-200 text-slate-700">
                    {concernedEntity.entite_libelle}
                  </span>
                </h2>
              </div>
              <div className="md:col-span-2">
                <label>Libellé:</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Libelle"
                  value={createEtablissementForm.libelle}
                  onChange={(e) =>
                    setCreateEtablissementForm((f) => ({ ...f, libelle: e.target.value }))
                  }
                />
              </div>

              <div className="md:col-span-2">
                <label>Trigramme:</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Trigramme"
                  value={createEtablissementForm.trigramme}
                  onChange={(e) =>
                    setCreateEtablissementForm((f) => ({ ...f, trigramme: e.target.value }))
                  }
                />
              </div>
              <div className="md:col-span-4 flex justify-end gap-2 mt-2">
                <Button type="button" onClick={() => setCreateEtablissementOpen(false)}>
                  Annuler
                </Button>
                <Button type="submit">Créer</Button>
              </div>
            </form>
          </div>,
          document.body,
        )}

      {updateEtablissementOpen &&
        createPortal(
          <div className="fixed top-0 left-0 w-full h-[100vh] z-[1002] flex items-center justify-center bg-black/30">
            <div
              className="absolute inset-0 bg-black/30"
              onClick={() => setUpdateEtablissementOpen(false)}
            />
            <form
              onSubmit={onUpdateEtablissement}
              className="relative z-10  w-max[80vw]  md:max-w-3xl mx-3 rounded-2xl bg-white shadow-xl p-4 grid grid-cols-1 md:grid-cols-4 gap-2"
            >
              <div className="md:col-span-4">
                <h2 className="md:col-span-6 text-lg font-semibold mb-1">
                  Modifier l'établissement
                </h2>
              </div>
              <div className="md:col-span-2">
                <label>Libellé:</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Libelle"
                  value={updateEtablissementForm.libelle}
                  onChange={(e) =>
                    setUpdateEtablissementForm((f) => ({ ...f, libelle: e.target.value }))
                  }
                />
              </div>
              <div className="md:col-span-2">
                <label>Trigramme:</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Trigramme"
                  value={updateEtablissementForm.trigramme}
                  onChange={(e) =>
                    setUpdateEtablissementForm((f) => ({ ...f, trigramme: e.target.value }))
                  }
                />
              </div>
              <div className="md:col-span-4 flex justify-end gap-2 mt-2">
                <Button type="button" onClick={() => setUpdateEtablissementOpen(false)}>
                  Annuler
                </Button>
                <Button type="submit">Modifier</Button>
              </div>
            </form>
          </div>,
          document.body,
        )}

      {createSalleOpen &&
        createPortal(
          <div className="fixed top-0 left-0 w-full h-[100vh] z-[1002] flex items-center justify-center bg-black/30">
            <div
              className="absolute inset-0 bg-black/30"
              onClick={() => setCreateSalleOpen(false)}
            />
            <form
              onSubmit={(e) => onCreateSalle(e)}
              className="relative z-10  w-max[80vw]  md:max-w-3xl mx-3 rounded-2xl bg-white shadow-xl p-4 grid grid-cols-1 md:grid-cols-2 gap-2"
            >
              <div className="md:col-span-2">
                <h2 className="md:col-span-6 text-lg font-semibold mb-1">
                  Nouvelle Salle pour l'établissement{' '}
                  <span className="bg-slate-200 text-slate-700">
                    {concernedEtablissement.etablissement_libelle}
                  </span>
                </h2>
              </div>
              <div className="md:col-span-1">
                <label>Nom:</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Nom"
                  value={createSalleForm.nom}
                  onChange={(e) => setCreateSalleForm((f) => ({ ...f, nom: e.target.value }))}
                />
              </div>

              <div className="md:col-span-1">
                <label>Type:</label>
                <select
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  value={createSalleForm.type}
                  onChange={(e) => setCreateSalleForm((f) => ({ ...f, type: e.target.value }))}
                >
                  <option value="">—</option>
                  {typesSalles.map((ts) => (
                    <option key={ts.id} value={ts.id}>
                      {ts.libelle}
                    </option>
                  ))}
                </select>
              </div>
              <div className="md:col-span-2 flex justify-end gap-2 mt-2">
                <Button type="button" onClick={() => setCreateSalleOpen(false)}>
                  Annuler
                </Button>
                <Button type="submit">Créer</Button>
              </div>
            </form>
          </div>,
          document.body,
        )}

      {updateSalleOpen &&
        createPortal(
          <div className="fixed top-0 left-0 w-full h-[100vh] z-[1002] flex items-center justify-center bg-black/30">
            <div
              className="absolute inset-0 bg-black/30"
              onClick={() => setUpdateSalleOpen(false)}
            />
            <form
              onSubmit={onUpdateSalle}
              className="relative z-10  w-max[80vw]  md:max-w-3xl mx-3 rounded-2xl bg-white shadow-xl p-4 grid grid-cols-1 md:grid-cols-2 gap-2"
            >
              <div className="md:col-span-2">
                <h2 className="text-lg font-semibold mb-1">Modifier la salle</h2>
              </div>
              <div className="md:col-span-1">
                <label>Nom:</label>
                <input
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  placeholder="Nom"
                  value={updateSalleForm.nom}
                  onChange={(e) => setUpdateSalleForm((f) => ({ ...f, nom: e.target.value }))}
                />
              </div>

              <div className="md:col-span-1">
                <label>Type:</label>
                <select
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                  value={updateSalleForm.type}
                  onChange={(e) => setUpdateSalleForm((f) => ({ ...f, type: e.target.value }))}
                >
                  <option value="">—</option>
                  {typesSalles.map((ts) => (
                    <option key={ts.id} value={ts.id}>
                      {ts.libelle}
                    </option>
                  ))}
                </select>
              </div>

              <div className="md:col-span-2 flex justify-end gap-2 mt-2">
                <Button type="button" onClick={() => setUpdateSalleOpen(false)}>
                  Annuler
                </Button>
                <Button type="submit">Modifier</Button>
              </div>
            </form>
          </div>,
          document.body,
        )}

      {loading ? (
        <p className="text-sm text-gray-500">Chargement…</p>
      ) : error ? (
        <p className="text-sm text-red-600">{error}</p>
      ) : entities.length === 0 ? (
        <p className="text-sm text-gray-500">Aucune entité</p>
      ) : (
        <div className="mt-3 space-y-2">
          {entities.map((entity) => {
            const isOpen = openIds.has(entity.entite_id);
            return (
              <div key={entity.entite_id} className="bg-white rounded-xl shadow p-3">
                <button
                  onClick={() => toggle(entity.entite_id)}
                  className="flex-1 text-left flex items-center gap-3"
                  title="Ouvrir / fermer"
                >
                  <span className="inline-block w-5 text-slate-500">
                    {isOpen ? <ChevronDown strokeWidth={3} /> : <ChevronRight strokeWidth={3} />}
                  </span>
                  <div className="font-medium truncate">
                    {entity.entite_libelle}{' '}
                    <span className="shrink-0 inline-flex items-center justify-center h-7 px-3 rounded-full bg-slate-200 text-slate-700 text-xs">
                      {entity.etablissements.length}{' '}
                      {' établissement' + (entity.etablissements.length > 1 ? 's' : '')}
                    </span>{' '}
                    <span className="shrink-0 inline-flex items-center justify-center h-7 px-3 rounded-full bg-slate-200 text-slate-700 text-xs">
                      {countSallesPerEntity(entity)}{' '}
                      {' salle' + (countSallesPerEntity(entity) > 1 ? 's' : '')}
                    </span>
                    <span className="hidden md:inline ml-2 text-xs text-gray-500">
                      ({entity.entite_id})
                    </span>
                  </div>
                </button>

                <div className="flex items-center justify-between gap-2">
                  <div className="min-w-0"></div>
                  <div className="flex-shrink-0 flex gap-2">
                    <Button
                      onClick={() => {
                        setCreateEtablissementOpen(true);
                        setConcernedEntity(entity);
                      }}
                    >
                      <CirclePlus size={20} className="inline-block" />
                      <span className="hidden md:inline ml-0.5">Ajouter un établissement</span>
                    </Button>
                    <Button
                      variant="danger"
                      onClick={() => {
                        setUpdateEntiteOpen(true);
                        handleSetUpdateEntiteForm(entity);
                      }}
                    >
                      <Edit size={20} className="inline-block" />
                      <span className="hidden md:inline ml-0.5">Modifier l'entité</span>
                    </Button>
                  </div>
                </div>

                {isOpen && (
                  <div className="mt-3 space-y-2">
                    {entity.etablissements.length === 0 ? (
                      <p className="text-sm text-gray-500">Aucun établissement dans cette entité</p>
                    ) : (
                      entity.etablissements.map((etablissement) => (
                        <div
                          key={etablissement.etablissement_id}
                          className="bg-gray-300 rounded-xl shadow p-3"
                        >
                          <div className="flex items-center justify-between gap-2">
                            <div className="min-w-0">
                              <div className="font-medium ">
                                {etablissement.etablissement_libelle + ' [' + etablissement.etablissement_trigramme + '] '}
                                <span className="shrink-0 inline-flex items-center justify-center h-7 px-3 rounded-full bg-slate-600 text-slate-50 text-xs">
                                  {etablissement.salles.length}{' '}
                                  {' salle' + (etablissement.salles.length > 1 ? 's' : '')}
                                </span>
                                <span className="hidden md:inline ml-2 text-xs text-gray-600">
                                  ({etablissement.etablissement_id})
                                </span>
                              </div>
                            </div>
                            <div className="flex-shrink-0 flex gap-2">
                              <Button
                                variant="danger"
                                onClick={() => {
                                  setCreateSalleOpen(true);
                                  setConcernedEtablissement(etablissement);
                                }}
                              >
                                <CirclePlus size={20} className="inline-block" />
                                <span className="hidden md:inline ml-0.5">Ajouter une salle</span>
                              </Button>
                              <Button
                                variant="danger"
                                onClick={() => {
                                  setUpdateEtablissementOpen(true);
                                  handleSetUpdateEtablissementForm(etablissement);
                                }}
                              >
                                <Edit size={20} className="inline-block" />
                                <span className="hidden md:inline ml-0.5">
                                  Modifier l'établissement
                                </span>
                              </Button>
                            </div>
                          </div>
                          <div className="mt-3 grid grid-cols-1 md:grid-cols-4 gap-3 auto-rows-fr">
                            {etablissement.salles.length === 0 ? (
                              <p className="text-sm text-gray-500">
                                Aucune salle dans cet établissement
                              </p>
                            ) : (
                              etablissement.salles.map((salle) => (
                                <div
                                  key={salle.salle_id}
                                  className="bg-gradient-to-r from-[#A51A1F] to-[#DB0E16] text-slate-50 rounded-xl shadow p-3 h-full inline-block"
                                >
                                  <div className="flex items-center justify-between gap-2">
                                    <div className="min-w-0">
                                      <div className="font-medium">
                                        {salle.salle_nom}{' '}
                                        {salle.salle_type && (
                                          <span className="shrink-0 inline-flex items-center justify-center h-7 px-3 rounded-full bg-slate-900 text-slate-50 text-xs">
                                            {
                                              typesSalles.find((ts) => ts.id === salle.salle_type)
                                                ?.libelle
                                            }
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="flex-shrink-0 flex gap-2">
                                      <Button
                                        variant="danger"
                                        onClick={() => {
                                          setUpdateSalleOpen(true);
                                          handleSetUpdateSalleForm(salle);
                                        }}
                                      >
                                        <Edit size={20} className="inline-block" />
                                        <span className="hidden {md:inline ml-0.5}">Modifier</span>
                                      </Button>
                                    </div>
                                  </div>
                                </div>
                              ))
                            )}
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                )}

                <div className="flex items-center justify-between gap-2"></div>
              </div>
            );
          })}
        </div>
      )}

      <div className="px-4 pt-2 pb-2 mt-12">
        {createGroupOpen &&
          createPortal(
            <div className="fixed top-0 left-0 w-full h-[100vh] z-[1002] flex items-center justify-center bg-black/30">
              <div
                className="absolute inset-0 bg-black/30"
                onClick={() => setCreateGroupOpen(false)}
              />
              <form
                onSubmit={onCreateGroup}
                className="relative z-10  w-max[80vw]  md:max-w-3xl mx-3 rounded-2xl bg-white shadow-xl p-4 grid grid-cols-1 md:grid-cols-2 gap-2"
              >
                <div className="md:col-span-2">
                  <h2 className="md:col-span-6 text-lg font-semibold mb-1">
                    Nouveau groupe pour l'établissement{' '}
                    {concernedEtablissement.etablissement_libelle}
                  </h2>
                </div>
                <div className="md:col-span-2">
                  <label>Libellé:</label>
                  <input
                    className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                    placeholder="Libelle"
                    value={createGroupForm.libelle}
                    onChange={(e) => setCreateGroupForm((f) => ({ ...f, libelle: e.target.value }))}
                  />
                </div>
                <div className="md:col-span-2 flex justify-end gap-2 mt-2">
                  <Button type="button" onClick={() => setCreateGroupOpen(false)}>
                    Annuler
                  </Button>
                  <Button type="submit">Créer</Button>
                </div>
              </form>
            </div>,
            document.body,
          )}

        {updateGroupOpen &&
          createPortal(
            <div className="fixed top-0 left-0 w-full h-[100vh] z-[1002] flex items-center justify-center bg-black/30">
              <div
                className="absolute inset-0 bg-black/30"
                onClick={() => setUpdateGroupOpen(false)}
              />
              <form
                onSubmit={onUpdateGroup}
                className="relative z-10  w-max[80vw]  md:max-w-3xl mx-3 rounded-2xl bg-white shadow-xl p-4 grid grid-cols-1 md:grid-cols-2 gap-2"
              >
                <div className="md:col-span-2">
                  <h2 className="md:col-span-6 text-lg font-semibold mb-1">Modifier le groupe</h2>
                </div>
                <div className="md:col-span-2">
                  <label>Libellé:</label>
                  <input
                    className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-300"
                    placeholder="Libelle"
                    value={updateGroupForm.libelle}
                    onChange={(e) => setUpdateGroupForm((f) => ({ ...f, libelle: e.target.value }))}
                  />
                </div>
                <div className="md:col-span-2 flex justify-end gap-2 mt-2">
                  <Button type="button" onClick={() => setUpdateGroupOpen(false)}>
                    Annuler
                  </Button>
                  <Button type="submit">Mettre à jour</Button>
                </div>
              </form>
            </div>,
            document.body,
          )}

        {deleteGroupOpen &&
          createPortal(
            <div className="fixed top-0 left-0 w-full h-[100vh] z-[1002] flex items-center justify-center bg-black/30">
              <div
                className="absolute inset-0 bg-black/30"
                onClick={() => setDeleteGroupOpen(false)}
              />
              <div className="relative z-10  w-max[80vw]  md:max-w-3xl mx-3 rounded-2xl bg-white shadow-xl p-4 grid grid-cols-1 md:grid-cols-2 gap-2">
                <div className="md:col-span-2 space-y-2">
                  <p>
                    Êtes-vous sûr de vouloir supprimer le groupe{' '}
                    <span className="bg-gray-400 pl-1 pr-1">{deleteGroupForm.libelle}</span>?
                  </p>
                  <p>Ce groupe contient {deleteGroupForm.nbSalles} salle(s)</p>
                </div>
                <div className="md:col-span-2 flex justify-end gap-2 mt-2">
                  <Button type="button" onClick={onDeleteGroup}>
                    Confirmer la suppression
                  </Button>
                </div>
              </div>
            </div>,
            document.body,
          )}

        {addSalleToGroupOpen &&
          createPortal(
            <div className="fixed top-0 left-0 w-full h-[100vh] z-[1002] flex items-center justify-center bg-black/30">
              <div
                className="absolute inset-0 bg-black/30"
                onClick={() => setAddSalleToGroupOpen(false)}
              />
              <form
                onSubmit={onAddSalleToGroup}
                className="relative z-10  w-max[80vw]  md:max-w-3xl mx-3 rounded-2xl bg-white shadow-xl p-4 grid grid-cols-1 md:grid-cols-2 gap-2"
              >
                <div className="md:col-span-2">
                  <h2 className="text-lg font-semibold mb-1">
                    Modifier les salles du groupe{' '}
                    <span className="bg-gray-300">{addSalleToGroupForm.group_libelle}</span>
                  </h2>
                </div>

                <div className="md:col-span-2 flex flex-col gap-2">
                  {addSalleToGroupForm.etablissement_salles?.map((salle) => (
                    <label key={salle.salle_id} className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={addSalleToGroupForm.group_salles.some(
                          (mSalle) => mSalle.salle_id === salle.salle_id,
                        )}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          toggleSalle(salle, checked);
                        }}
                      />
                      {salle.salle_nom}
                    </label>
                  ))}
                </div>
                <div className="md:col-span-2 flex justify-end gap-2 mt-2">
                  <Button type="button" onClick={() => setAddSalleToGroupOpen(false)}>
                    Annuler
                  </Button>
                  <Button type="submit">Mettre à jour</Button>
                </div>
              </form>
            </div>,
            document.body,
          )}

        <div className="flex flex-wrap items-center justify-between mb-3">
          <h1 className="text-xl font-semibold">Gestion des Groupes</h1>
          <>
            {loading ? (
              <p className="text-sm text-gray-500">Chargement…</p>
            ) : error ? (
              <p className="text-sm text-red-600">{error}</p>
            ) : entities.length === 0 ? (
              <p className="text-sm text-gray-500">Aucune entité</p>
            ) : (
              <div className="mt-3 space-y-2 w-full block">
                {entities.map((entity) => {
                  const etablissements = entity.etablissements;
                  const isOpen = openIds.has('grps-' + entity.entite_id);
                  return (
                    <div key={'grps-' + entity.entite_id}>
                      {etablissements.map((etablissement) => (
                        <div key={'grps-' + etablissement.etablissement_id}>
                          <div className="mt-3 space-y-2">
                            <div className="bg-white rounded-xl shadow p-3">
                              <button
                                onClick={() => toggle('grps-' + entity.entite_id)}
                                className="flex-1 text-left flex items-center gap-3"
                                title="Ouvrir / fermer"
                              >
                                <span className="inline-block w-5 text-slate-500">
                                  {isOpen ? (
                                    <ChevronDown strokeWidth={3} />
                                  ) : (
                                    <ChevronRight strokeWidth={3} />
                                  )}
                                </span>
                                <div className="font-medium truncate">
                                  {etablissement.etablissement_libelle}{' '}
                                  <span className="shrink-0 inline-flex items-center justify-center h-7 px-3 rounded-full bg-slate-200 text-slate-700 text-xs">
                                    {countGroupsPerEtablissement(etablissement)}{' '}
                                    {' groupe' +
                                      (countGroupsPerEtablissement(etablissement) > 1 ? 's' : '')}
                                  </span>{' '}
                                </div>
                              </button>

                              <div className="flex items-center justify-between gap-2">
                                <div className="min-w-0"></div>
                                <div className="flex-shrink-0 flex gap-2">
                                  <Button
                                    onClick={() => {
                                      setCreateGroupOpen(true);
                                      setConcernedEtablissement(etablissement);
                                    }}
                                  >
                                    <CirclePlus size={20} className="inline-block" />
                                    <span className="/*hidden*/ md:inline ml-0.5">
                                      Ajouter un groupe
                                    </span>
                                  </Button>
                                </div>
                              </div>
                              {(() => {
                                const filteredGroups = groups.filter(
                                  (mGroup) =>
                                    mGroup.etablissement.etablissement_id ===
                                    etablissement.etablissement_id,
                                );

                                if (filteredGroups.length === 0 && isOpen) {
                                  return (
                                    <p className="text-gray-500 italic">
                                      Aucun groupe pour cet établissement
                                    </p>
                                  );
                                }
                                if (isOpen) {
                                  return filteredGroups.map((mGroup) => (
                                    <div
                                      key={mGroup.group_id}
                                      className="bg-gray-300 rounded-xl shadow p-3 mb-2 mt-1"
                                    >
                                      <div className="flex items-center justify-between gap-2">
                                        <div className="min-w-0">
                                          <div className="font-medium ">
                                            {mGroup.group_libelle + ' '}
                                            <span className="shrink-0 inline-flex items-center justify-center h-7 px-3 rounded-full bg-slate-700 text-slate-50 text-xs">
                                              {mGroup.salles.length}{' '}
                                              {' salle' + (mGroup.salles.length > 1 ? 's' : '')}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="flex-shrink-0 flex gap-2">
                                          <Button
                                            variant="danger"
                                            onClick={() => {
                                              setAddSalleToGroupOpen(true);
                                              handleSetAddSalleToGroupForm(mGroup, etablissement);
                                            }}
                                          >
                                            <Cog size={20} className="inline-block" />
                                            <span className="hidden md:inline ml-0.5">
                                              Gérer les salles
                                            </span>
                                          </Button>
                                          <Button
                                            variant="danger"
                                            onClick={() => {
                                              setUpdateGroupOpen(true);
                                              handleSetUpdateGroupForm(mGroup);
                                            }}
                                          >
                                            <Edit size={20} className="inline-block" />
                                            <span className="hidden md:inline ml-0.5">
                                              Renommer le groupe
                                            </span>
                                          </Button>
                                          <Button
                                            variant="danger"
                                            onClick={() => {
                                              setDeleteGroupOpen(true);
                                              handleSetDeleteGroupForm(mGroup);
                                            }}
                                          >
                                            <Trash2 size={20} className="inline-block" />
                                            <span className="hidden md:inline ml-0.5">
                                              Supprimer le groupe
                                            </span>
                                          </Button>
                                        </div>
                                      </div>
                                      <div className="mt-3 grid grid-cols-1 md:grid-cols-4 gap-3 auto-rows-fr">
                                        {mGroup.salles.length === 0 ? (
                                          <p className="text-sm text-gray-500">
                                            Aucune salle dans ce groupe
                                          </p>
                                        ) : (
                                          mGroup.salles.map((salle) => (
                                            <div
                                              key={salle.salle_id}
                                              className="bg-gradient-to-r from-[#A51A1F] to-[#DB0E16] text-slate-50 rounded-xl shadow p-3 h-full inline-block"
                                            >
                                              <div className="flex items-center justify-between gap-2">
                                                <div className="min-w-0">
                                                  <div className="font-medium">
                                                    {salle.salle_nom}{' '}
                                                    {salle.salle_type && (
                                                      <span className="shrink-0 inline-flex items-center justify-center h-7 px-3 rounded-full bg-slate-900 text-slate-50 text-xs">
                                                        {
                                                          typesSalles.find(
                                                            (ts) => ts.id === salle.salle_type,
                                                          )?.libelle
                                                        }
                                                      </span>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ))
                                        )}
                                      </div>
                                    </div>
                                  ));
                                }
                              })()}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  );
                })}
              </div>
            )}
          </>
        </div>
      </div>
    </PageLayout>
  );
}


